import { convertSeoModel } from '@wix/advanced-seo-utils/converters'
import { BaseDataItem } from '@wix/thunderbolt-becky-types'

type PageDataItem = BaseDataItem<'Page'> & { advancedSeoData: string }
const isPageDataItem = (dataItem: any): dataItem is PageDataItem => dataItem.type === 'Page'

const seoMergeBlob = (originalPageData: PageDataItem, translatedPageData: PageDataItem) => {
	const original = convertSeoModel(originalPageData?.advancedSeoData || '')
	const translated = convertSeoModel(translatedPageData?.advancedSeoData || '')

	const advancedSeoData = translatedPageData?.id ? translated : original
	// @ts-expect-error preserve original tpaApplicationId and compId if exists
	const { pageSecurity, tpaApplicationId, compId, type } = originalPageData
	return {
		...originalPageData,
		...translatedPageData,
		advancedSeoData: JSON.stringify(advancedSeoData),
		...(pageSecurity && { pageSecurity }),
		...(tpaApplicationId && { tpaApplicationId }),
		...(compId && { compId }),
		...(type && { type }),
	}
}

export const applyTranslation = (dataItem: BaseDataItem | undefined, translatedDataItem: BaseDataItem) => {
	if (!dataItem) {
		return translatedDataItem
	}

	// @ts-expect-error preserve original tpaApplicationId and compId if exists
	const { tpaApplicationId, compId, type } = dataItem

	if (type !== translatedDataItem.type || type === 'Repeater') {
		return dataItem
	}

	if (isPageDataItem(dataItem) && isPageDataItem(translatedDataItem)) {
		return seoMergeBlob(dataItem, translatedDataItem)
	}

	return {
		...dataItem,
		...translatedDataItem,
		...(tpaApplicationId && { tpaApplicationId }),
		...(compId && { compId }),
	}
}
